// src/components/Timer/Celebration.js

import React, { useEffect } from 'react';
import './Celebration.css';


function Celebration({ endCelebration }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      endCelebration();
    }, 3000); // Show for 3 seconds

    return () => clearTimeout(timer);
  }, [endCelebration]);

  return (
    <div className="celebration">
      🎉 Session Complete! 🎉
    </div>
  );
}

export default Celebration;
